var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 3.33368C18.3332 3.33368 17.7498 5.08368 16.6665 6.16701C17.9998 14.5003 8.83317 20.5837 1.6665 15.8337C3.49984 15.917 5.33317 15.3337 6.6665 14.167C2.49984 12.917 0.416504 8.00034 2.49984 4.16701C4.33317 6.33368 7.1665 7.58368 9.99984 7.50035C9.24984 4.00034 13.3332 2.00034 15.8332 4.33368C16.7498 4.33368 18.3332 3.33368 18.3332 3.33368Z",
    stroke: "#1A4D3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9c0202eedb847f89735f48e4b3714e47.svg";
export { ForwardRef as ReactComponent };